module.exports = __webpack_public_path__ + "static/media/driver-svgrepo-com.705c3d02.svg";